export default __webpack_public_path__ + "static/media/arrow-icon.58a9b04d.svg";